
<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header>
            <h4 class="title">Pending Pre-Order Requests</h4>
            <p class="category">Here is pending request items</p>
          </md-card-header>
          <md-card-content>
            <!-- <simple-table table-header-color="green"></simple-table> -->
            <md-table v-model="Itemlist" :table-header-color="tableHeaderColor">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Image">
                  <img
                    v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + item.image_url"
                    class="good-image"
                    style="width: 100%;"
                  />
                </md-table-cell>
                <md-table-cell md-label="Date">{{ item.created_date | formatDate}}</md-table-cell>
                <md-table-cell md-label="Item Name">{{ item.item_name | truncate(30)}}</md-table-cell>
                <md-table-cell
                  md-label="Product Description"
                >{{ item.item_description | truncate(40)}}</md-table-cell>
                <md-table-cell md-label="User Name">{{ item.full_name }}</md-table-cell>
                <md-table-cell md-label="Item Price">{{ item.will_pay | currency('Rs ')}}</md-table-cell>
                <md-table-cell md-label="Quantity" class="t-center">{{ item.qty}}</md-table-cell>
                <md-table-cell md-label="Service Fee">{{ item.service_fee | currency('Rs ')}}</md-table-cell>
                <md-table-cell md-label="Total Price">{{ item.total_pay | currency('Rs ')}}</md-table-cell>
                <md-table-cell md-label="Action">
                  <md-button class="view-u" @click="viewSelectItem(item.id)">
                    <md-icon>visibility</md-icon>
                  </md-button>
                  <md-button class="edit-u" @click="editSelectItem(item.id)">
                    <md-icon>create</md-icon>
                  </md-button>
                  <md-button class="clear-u" @click="deleteSelectItem(item.id)">
                    <md-icon>delete_forever</md-icon>
                  </md-button>
                  <md-button class="done-u" @click="confirmSelectItem(item.id)">
                    <md-icon>done</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <!-- ========== View Item Model =================== -->
      <md-dialog :md-active.sync="viewItem" class="popUp-width">
        <div class="md-dialog-content">
          <div class="row">
            <div class="col-md-12">
              <div class="close text-right">
                <a class="md-primary" @click="viewItem = false">
                  <md-icon class="close-btn">close</md-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5" style="border-right: 1px solid #eaeaea;">
              <img
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img1"
                class="good-image"
                style="width: 100%;padding: 5px;"
              />
              <img
                v-if="this.img2"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img2"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <img
                v-if="this.img3"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img3"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <img
                v-if="this.img3"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img3"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <div class="price-infor-title">Others Information</div>
              <table class="price-info">
                <tr class="p-row">
                  <td class="p-lable">Country</td>
                  <td class="p-value">
                    <img
                      class="my_flag"
                      v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/Flags/'+selectItem.country_iso+'.png'"
                    />
                    {{selectItem.country_name }}
                  </td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Validity Date</td>
                  <td class="p-value">{{selectItem.validity_date | formatDate2}}</td>
                </tr>
              </table>

              <div class="price-infor-title">Payment Information</div>
              <table class="price-info">
                <tr class="p-row">
                  <td class="p-lable">Quantity</td>
                  <td class="p-value">{{selectItem.qty }}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Unit Price</td>
                  <td class="p-value">{{selectItem.will_pay | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Total Price</td>
                  <td class="p-value">{{selectItem.total_pay | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Service fee</td>
                  <td
                    class="p-value"
                  >{{parseFloat(selectItem.service_fee) + parseFloat(this.cardfeeAmount) | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Requester will pay</td>
                  <td
                    class="p-value"
                  >{{selectItem.traveler_pay + parseFloat(this.cardfeeAmount)| currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">
                    <strong>Total amount</strong>
                  </td>
                  <td class="p-value">
                    <strong>{{selectItem.total_pay | currency('Rs ')}}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-md-7">
              <div class="price-infor-title-item">Item Information</div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Item Name</label>
                    <md-input type="text" :disabled="isDisabled" v-model="itemData.name"></md-input>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Item description</label>
                    <md-textarea
                      md-autogrow
                      :disabled="isDisabled"
                      v-model="itemData.description"
                      :maxlength="100"
                    ></md-textarea>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Item refer url</label>
                    <md-input type="text" :disabled="isDisabled" v-model="itemData.url"></md-input>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field>
                    <md-select v-model="itemData.category" placeholder="Select a category">
                      <md-option
                        :disabled="isDisabled"
                        :value="cata.value"
                        v-for="cata in categorylist"
                        v-bind:key="cata.value"
                      >{{cata.label}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Delivery location</label>
                    <md-input type="text" :disabled="isDisabled" v-model="itemData.address"></md-input>
                  </md-field>
                </div>
                <br />
                <div class="col-sm-12">
                  <label class="check-claim">Which Receipt want</label>
                  <md-checkbox v-model="itemData.invoice">
                    <p class="sub">Request Invoice</p>
                  </md-checkbox>
                  <md-checkbox v-model="itemData.gst">
                    <p class="sub">Request GST Claim</p>
                  </md-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog>
      <!-- ========== Edit Item Model =================== -->
      <md-dialog :md-active.sync="editItem" class="popUp-width">
        <div class="md-dialog-content">
          <div class="row">
            <div class="col-md-12">
              <div class="close text-right">
                <a class="md-primary" @click="editItem = false">
                  <md-icon class="close-btn">close</md-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5" style="border-right: 1px solid #eaeaea;">
              <img
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img1"
                class="good-image"
                style="width: 100%;padding: 5px;"
              />
              <img
                v-if="this.img2"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img2"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <img
                v-if="this.img3"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img3"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <img
                v-if="this.img3"
                v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/' + this.img3"
                class="good-image"
                style="width: 20%;padding: 5px;"
              />
              <div class="price-infor-title">Others Information</div>
              <table class="price-info">
                <tr class="p-row">
                  <td class="p-lable">Country</td>
                  <td class="p-value">
                    <img
                      class="my_flag"
                      v-bind:src="'https://airbuddyimage.s3.us-east-2.amazonaws.com/Flags/'+selectItem.country_iso+'.png'"
                    />
                    {{selectItem.country_name }}
                  </td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Validity Date</td>
                  <td class="p-value">{{selectItem.validity_date | formatDate2}}</td>
                </tr>
              </table>

              <div class="price-infor-title">Payment Information</div>
              <table class="price-info">
                <tr class="p-row">
                  <td class="p-lable">Quantity</td>
                  <td class="p-value">{{selectItem.qty }}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Unit Price</td>
                  <td class="p-value">{{selectItem.will_pay | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Total Price</td>
                  <td class="p-value">{{selectItem.total_pay | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Service fee</td>
                  <td
                    class="p-value"
                  >{{parseFloat(selectItem.service_fee) + parseFloat(this.cardfeeAmount) | currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">Requester will pay</td>
                  <td
                    class="p-value"
                  >{{selectItem.traveler_pay + parseFloat(this.cardfeeAmount)| currency('Rs ')}}</td>
                </tr>
                <tr class="p-row">
                  <td class="p-lable">
                    <strong>Total amount</strong>
                  </td>
                  <td class="p-value">
                    <strong>{{selectItem.total_pay | currency('Rs ')}}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-md-7">
              <div class="price-infor-title-item">Item Information</div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Item Name</label>
                    <md-input type="text" v-model="itemData.name"></md-input>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field>
                    <label>Item description</label>
                    <md-textarea md-autogrow v-model="itemData.description" :maxlength="100"></md-textarea>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Item refer url</label>
                    <md-input type="text" :disabled="isDisabled" v-model="itemData.url"></md-input>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field>
                    <md-select v-model="itemData.category" placeholder="Select a category">
                      <md-option
                        :value="cata.value"
                        v-for="cata in categorylist"
                        v-bind:key="cata.value"
                      >{{cata.label}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="col-sm-12">
                  <md-field class="filed">
                    <label>Delivery location</label>
                    <md-input type="text" :disabled="isDisabled" v-model="itemData.address"></md-input>
                  </md-field>
                </div>
                <br />
                <div class="col-sm-12">
                  <label class="check-claim">Which Receipt want</label>
                  <md-checkbox v-model="itemData.invoice">
                    <p class="sub">Request Invoice</p>
                  </md-checkbox>
                  <md-checkbox v-model="itemData.gst">
                    <p class="sub">Request GST Claim</p>
                  </md-checkbox>
                </div>

                <div class="col-sm-12">
                  <button
                    type="submit"
                    @click="updateItem()"
                    class="btn btn-primary btn-Done"
                  >Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      cardFee: "",
      cardfeeAmount: "",
      isDisabled: true,
      viewItem: false,
      editItem: false,
      doneItem: false,
      Itemlist: [],
      ImageList: [],
      categorylist: [],
      selectItem: "",
      img1: "",
      img2: "",
      img3: "",
      img4: "",
      selected: {
        code: "",
        type: "PreOrder-Request"
      },
      itemData: {
        code: "",
        name: "",
        description: "",
        url: "",
        category: "",
        address: "",
        invoice: false,
        gst: false
      }
    };
  },
  created() {
    this.setRequestItem();
    this.setCategory();
    this.getCardFee();
    
  },
  methods: {
    getCardFee() {
      this.axios.get("/card-fee").then(response => {
        this.cardFee = response.data.data.fee;
      });
    },
    deleteSelectItem(id) {
      this.selected.code = id;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't reject this item!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ffc107",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, reject it!"
      }).then(result => {
        if (result.value) {
          this.axios
            .post("/admin/preorderRequest/remove", this.selected)
            .then(response => {
              this.setRequestItem();
            });
          Swal.fire(
            "Rejected!",
            "This post request has been rejected.",
            "success"
          );
        }
      });
    },
    confirmSelectItem(id) {
      this.selected.code = id;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't confirm this item!",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#ffc107",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, confirm it!"
      }).then(result => {
        if (result.value) {
          this.axios
            .post("/admin/preorderRequest/confirm", this.selected)
            .then(response => {
              this.setRequestItem();
            });
          Swal.fire(
            "confirmed!",
            "This post request has been confirmed.",
            "success"
          );
        }
      });
    },
    notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message:
          "Welcome to <b>Material Dashboard</b> - a beautiful freebie for every web developer.",
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "success"
      });
    },
    updateItem() {
      this.editItem = false;

      this.axios
        .post("/admin/preorderRequest/update", this.itemData)
        .then(response => {
          this.notifyVue("top", "right");
        });
    },
    editSelectItem(id) {
      this.selected.code = id;
      this.editItem = true;
      this.loadItemSingale();
    },
    viewSelectItem(id) {
      this.selected.code = id;
      this.viewItem = true;
      this.loadItemSingale();
    },
    loadItemSingale() {
      (this.img1 = ""),
        (this.img2 = ""),
        (this.img3 = ""),
        (this.img4 = ""),
        this.axios
          .post("/admin/preorderRequest/singale", this.selected)
          .then(response => {
            this.selectItem = response.data.item;
            this.ImageList = response.data.image;

            this.cardfeeAmount =
              (this.selectItem.total_pay * this.cardFee) / 100;

            this.cardfeeAmount = this.cardfeeAmount.toFixed(2);

            for (var i = 1; i <= this.ImageList.length; i++) {
              if (i == 1) {
                this.img1 = this.ImageList[0].image_url;
              }
              if (i == 2) {
                this.img2 = this.ImageList[1].image_url;
              }
              if (i == 3) {
                this.img3 = this.ImageList[2].image_url;
              }
              if (i == 4) {
                this.img4 = this.ImageList[3].image_url;
              }
            }
            this.itemData.code = this.selectItem.id;
            this.itemData.name = this.selectItem.item_name;
            this.itemData.description = this.selectItem.item_description;
            this.itemData.url = this.selectItem.item_url;
            this.itemData.category = this.selectItem.idcategory;
            if (this.selectItem.invoice_request) {
              this.itemData.invoice = true;
            }
            if (this.selectItem.gst_request) {
              this.itemData.gst = true;
            }
            this.itemData.address =
              this.selectItem.province +
              " Province / " +
              this.selectItem.district +
              " District / " +
              this.selectItem.city +
              " City ";
          });
    },

    setRequestItem() {
      this.axios.get("/admin/preorderRequest").then(response => {
        this.Itemlist = response.data.data;
      });
    },
    setCategory() {
      this.axios.get("/product/category").then(response => {
        this.categorylist = response.data.data;
      });
    }
  }
};
</script>
<style  scoped>
.md-card .md-card-header {
  -webkit-box-shadow: 0px 5px 0px -12px rgba(0, 0, 0, 0.42),
    0 4px 7px 0px rgba(0, 0, 0, 0.12), 0px 6px 7px -5px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 5px 0px -12px rgba(0, 0, 0, 0.42),
    0 4px 7px 0px rgba(0, 0, 0, 0.12), 0px 6px 7px -5px rgba(0, 0, 0, 0.2);
  margin: -20px 15px 0;
  border-radius: 4px;
  padding: 10px 20px;
  background-color: #2fd689 !important;
}
.md-card .md-card-header .title {
  color: #ffffff;
  font-weight: 600;
}
.md-card .md-card-header .category {
  font-weight: 500;
}
.md-table-cell-container {
  padding: 0;
  font-size: 13px;
}
.t-center {
  text-align: center;
}
.popUp-width {
  border-radius: 8px;
  min-width: 70% !important;
  max-width: 70% !important;
}
@media (max-width: 575px) {
  .popUp-width {
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
.check-claim {
  width: 100%;
  margin-top: 20px;
}
.filed {
  margin: 4px 0 10px !important;
}
.md-checkbox {
  margin: 6px 16px 6px 0 !important;
}
</style>

